import { render, staticRenderFns } from "./duration-text.vue?vue&type=template&id=d1fa5e5c&"
import script from "./duration-text.vue?vue&type=script&lang=js&"
export * from "./duration-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports